module.exports = __webpack_public_path__ + "img/_icon-calendar.0b8bd18a.svg";